module.exports = __webpack_public_path__ + "static/media/window-resize.d8d309bb.svg";